import { moment } from "store/util/moment"
import { rootStore } from "store/RootStore"
import { formatDate, formatDuration, languageName } from "./IntlManager"
import { l10n } from "store/lang/L10n"

export const nDash = "\u2013"

// Number(null) -> 0
// Number(undefinded) -> NaN

// helper functions while transitioning to CoCo event details, recordings are still using traxis events/naming

export const dateAndTime = (event) => {
	if (!event) console.warn("dateAndTime:", event)
	const start = event?.start ?? event?.startMillis ?? event?.AvailabilityStartTs
	const end = event?.end ?? event?.endMillis ?? event?.AvailabilityEndTs
	const val = formatDate(moment(start).utc().valueOf(), `dd DD.MM.YYYY, HH:mm`) + nDash + formatDate(moment(end).utc().valueOf(), (`HH:mm`))
	//console.debug("helper dateAndTime", val)
	return val
}

export const eventTime = (event) => {
	if (!event) console.warn("eventTime:", event)
	const start = event?.start ?? event?.startMillis ?? event?.AvailabilityStartTs
	const end = event?.end ?? event?.endMillis ?? event?.AvailabilityEndTs
	const val = formatDasssste(moment(start).utc().valueOf(), `HH:mm`) + nDash + formatDate(moment(end).utc().valueOf(), `HH:mm`)
	//console.debug("helper eventTime", val)
	return val
}

export const durationInSeconds = (event) => {
	if (!event) console.warn("durationInSeconds:", event)
	const startTs = Number(event?.startMillis ?? event?.AvailabilityStartTs ?? null)
	const endTs = Number(event?.endMillis ?? event?.AvailabilityEndTs ?? null)
	const val = Math.round(moment.duration(moment(endTs).diff(moment(startTs))).asSeconds())
	//console.debug("helper durationInSeconds", val)
	return val
}

export const durationInMinutes = (event) => {
	if (!event) console.warn("durationInMinutes:", event)
	const startTs = Number(event?.startMillis ?? event?.AvailabilityStartTs ?? null)
	const endTs = Number(event?.endMillis ?? event?.AvailabilityEndTs ?? null)
	const val = Math.round(moment.duration(moment(endTs).diff(moment(startTs))).asMinutes())
	//console.debug("helper durationInMinutes", val)
	return val
}

export const durationInHoursAndMinutes = (event, mins = null) => {
	if (!event && !mins) console.warn("durationInHoursAndMinutes:", event, mins)
	const durationMinutes = event ? durationInMinutes(event) : Math.round(Number(mins))
	const hours = Math.trunc(durationMinutes / 60)
	const minutes = durationMinutes % 60
	/*
	let val = ""
	if (hours > 0 && minutes > 0) val = l10n.featureDetailsDurationMetadataForLongShows.format(hours, minutes)
	else if (hours > 0) val = l10n.featureDetailsDurationMetadataForLongShowsOnlyHours.format(hours)
	else val = l10n.featureDetailsDurationMetadataForShortShows.format(minutes)
	*/
	const val = formatDuration(hours, minutes)
	//console.debug("helper durationInHoursAndMinutes", val)
	return val
}

export const startTs = (event) => {
	//if (!event) console.warn("startTs:", event)
	// start can be ts or date
	let _start = event?.start
	if (_start && typeof _start === "bigint") _start = Number(_start)
	const val = Number(event?.startMillis ?? event?.event?.startMillis ?? moment(_start).valueOf() ?? event?.AvailabilityStartTs ?? event?.AvailabilityStartDateTs ?? null)
	//console.debug("helper startTs", val)
	return val
}

export const endTs = (event) => {
	if (!event) console.warn("endTs:", event)
	// end can be ts or date
	let _end = event?.end
	if (_end && typeof _end === "bigint") _end = Number(_end)
	const val = Number(event?.endMillis ?? event?.event?.endMillis ?? moment(_end).valueOf() ?? event?.AvailabilityEndTs ?? event?.AvailabilityEndDateTs ?? null)
	//console.debug("helper endTs", val)
	return val
}

export const isTimeInEventRange = (time, event) => {
	if (!event) console.warn("isTimeInEventRange:", event)
	const val = moment(startTs(event)).isSameOrBefore(time) && moment(endTs(event)).isAfter(time)
	//console.debug("helper isTimeInEventRange", val)
	return val
}

export const startMoment = (event) => {
	if (!event) console.debug("startMoment:", event)
	const val = moment(event?.startMillis ?? event?.event?.startMillis) ?? event?.AvailabilityStartDate ?? null
	//console.debug("helper startMoment", val)
	return val
}

export const endMoment = (event) => {
	if (!event) console.debug("endMoment:", event)
	const val = moment(event?.endMillis ?? event?.event?.endMillis) ?? event?.AvailabilityEndDate ?? null
	//console.debug("helper endMoment", val)
	return val
}

export const eventType = (event) => {
	if (!event) console.warn("eventType:", event)
	const timeCurr = moment().utc().valueOf()
	const start = startTs(event)
	const end = endTs(event)
	const val = start <= timeCurr && end > timeCurr ? "c" : start >= timeCurr ? "n" : "p"
	//console.debug("helper eventType", val, start, end, timeCurr, event)
	return val
}

export const durationInPercent = (event) => {
	if (!event) console.warn("durationInPercent:", event)
	const timeCurr = moment().utc().valueOf()
	const startTs = Number(event?.startMillis ?? event?.AvailabilityStartTs ?? event?.AvailabilityStartDateTs)
	const endTs = Number(event?.endMillis ?? event?.AvailabilityEndTs ?? event?.AvailabilityEndDateTs)
	const eventType = startTs <= timeCurr && endTs > timeCurr ? "c" : startTs >= timeCurr ? "n" : "p"
	if (eventType !== "c") return 0
	const val = parseFloat(((100 * (timeCurr - startTs)) / (endTs - startTs)).toFixed(2))
	//console.debug("helper durationInPercent", val)
	return val
}

export const startDateFormat = (event, format) => {
	if (!event) {
		console.warn("startDateFormat:", event)
		// MTVW-1129: guard against missing event to prevent crash, return empty string if event is not set
		return ""
	}
	const startTs = Number(event?.startMillis ?? event?.start ?? event?.AvailabilityStartTs ?? event?.AvailabilityStartDateTs)
	const val = formatDate(moment(startTs).utc().valueOf(), format)
	//console.debug("helper startDateFormat", val)
	return val
}

export const endDateFormat = (event, format) => {
	if (!event) {
		console.warn("endDateFormat:", event)
		// MTVW-1129: guard against missing event to prevent crash, return empty string if event is not set
		return ""
	}
	const endTs = Number(event?.endMillis ?? /*event?.end_millis ??*/ event?.AvailabilityEndTs ?? event?.AvailabilityEndDateTs)
	const val = formatDate(moment(endTs).utc().valueOf(), format)
	//console.debug("helper endDateFormat", val)
	return val
}

// MTVW-1075: additional helpers
export const channelId = (event) => {
	if (!event) console.warn("channelId:", event)
	const val = event?.channelId ?? event?.event?.channelId ?? event?.ChannelId ?? null
	//console.debug("helper channelId", val)
	return val
}

export const bookmarkPercentage = (bm, event) => {
	if (!bm || !event) console.warn("bookmarkProgress:", bm, event)
	const bmProgress = 100 * ((bm.position - startTs(event)) / (endTs(event) - startTs(event)))
	// MTVW-946: cap bookmark progress
	//console.debug("helper bookmarkPercentage", bmProgress)
	return Math.min(bmProgress, 100)
}

export const eventPercentage = (event) => {
	if (!event) console.warn("eventPercentage:", event)
	const val = 100 * (moment().utc().valueOf() - startTs(event)) / (endTs(event) - startTs(event))
	//console.debug("helper eventPercentage", val)
	return Math.min(Math.max(val, 0), 100)
}

export const eventId = (event) => {
	//if (!event) console.warn("eventId:", event)
	const val = event?.id ?? event?.event?.id ?? event?.EventId ?? null
	//console.debug("helper eventId", val)
	return val
}

export const genres = (event) => {
	if (!event) console.warn("genres:", event)
	const val = event?.content?.genres ?? event?.Title?.Genres ?? event?.content?.Genres ?? null
	//console.debug("helper genres", val)
	return val
}

export const productionLocation = (event) => {
	if (!event) console.warn("productionLocation:", event)
	const val = event?.content?.productionLocations ?? event?.Title?.ProductionLocationId ?? null
	//console.debug("helper productionLocation", val)
	return val
}

export const isSeries = (event) => {
	if (!event) console.warn("isSeries:", event)
	const val = event?.isSeries ?? !!event?.content?.seriesId ?? event?.Title?.isSeries ?? false
	//console.debug("helper isSeries", val)
	return val
}

export const seriesId = (event) => {
	if (!event) {
		//console.warn("seriesId:", event)
		//debugger
	}
	const val = event?.content?.seriesId ?? event?.content?.SeriesId ?? event?.Title?.SeriesId ?? null
	//console.debug("helper seriesId", val)
	return val
}

export const seriesCollectionId = (event) => {
	if (!event) console.warn("seriesCollectionId:", event)
	const val = event?.content?.seriesCollectionId ?? null
	//console.debug("helper seriesCollectionId", val)
	return val
}

export const language = (event) => {
	if (!event) console.warn("language:", event)
	//const val = event?.content?.languageId ?? event?.Title?.OriginalLanguageName ?? null
	const val = event?.content?.languageId ? languageName(event?.content?.languageId) : event?.Title?.OriginalLanguageName ?? null
	//console.debug("helper language", val)
	return val
}

export const productionYear = (event) => {
	if (!event) console.warn("productionYear:", event)
	const val = event?.content?.productionYear ?? event?.Title?.ProductionDate ?? null
	//console.debug("helper productionYear", val)
	return val
}

export const ageRating = (event) => {
	if (!event) console.warn("ageRating:", event)
	const val = event?.content?.rating ?? event?.Title?.Rating ?? null
	//console.debug("helper ageRating", val)
	return val
}

export const season = (event) => {
	if (!event) console.warn("season:", event)
	const val = event?.content?.season ? Number(event?.content?.season) : event?.content?.Season ?? event?.Title?.SeasonNum ?? null
	//console.debug("helper season", val)
	return val
}

export const episode = (event) => {
	if (!event) console.warn("episode:", event)
	const val = event?.content?.episode ? Number( event?.content?.episode) : event?.content?.Episode ?? event?.Title?.EpisodeNum ?? null
	//console.debug("helper episode", val)
	return val
}

export const episodeName = (event) => {
	if (!event) console.warn("episodeName:", event)
	const val = event?.content?.episodeName ?? event?.content?.EpisodeName ?? event?.Title?.EpisodeName ?? null
	//console.debug("helper episodeName", val)
	return val
}

export const title = (event) => {
	if (!event) console.warn("title:", event)
	const val = event?.content?.title ?? event?.Title?.Name ?? event?.content?.Title ?? null
	//console.debug("helper title", val)
	return val
}

export const actors = (event) => {
	if (!event) console.warn("actors:", event)
	const val = event?.content?.actors ?? event?.Title?.Credits?.Actors ?? null
	//console.debug("helper actors", val)
	return val
}

export const directors = (event) => {
	if (!event) console.warn("directors:", event)
	const val = event?.content?.directors ?? event?.Title?.Credits?.Directors ?? null
	//console.debug("helper directors", val)
	return val
}

export const synopsis = (event) => {
	if (!event) console.warn("synopsis:", event)
	const val = event?.content?.description ?? event?.Title?.LongSynopsis ?? null
	//console.debug("helper synopsis", val)
	return val
}

export const currentDurationInMinutes = (event) => {
	if (!event) console.warn("currentDurationInMinutes:", event)
	const val = moment.duration(moment(rootStore.time.getTimeStampTick(30)).diff(moment(startTs(event)))).asMinutes()
	//console.debug("helper currentDurationInMinutes", val)
	return val
}

export const currentDurationInPercents = (event) => {
	if (!event) console.warn("currentDurationInPercents:", event)
	let val = 0
	const durMinutes = durationInMinutes(event)
	if (durMinutes) {
		const curMinutes = currentDurationInMinutes(event)
		val = (curMinutes / durMinutes) * 100
	}
	//console.debug("helper currentDurationInPercents", val)
	return val
}

export const posterUrl = (event) => {
	if (!event) console.warn("posterUrl:", event)
	const val = event?.content?.posterUrl ?? event?.Title?.BoxCover ?? event?.Data?.Title?.Pictures?.getBoxCover ?? null
	//console.debug("helper posterUrl", val)
	return val
}

export const contentId = (event) => {
	if (!event) console.warn("contentId:", event)
	const val = event?.content?.id ?? event?.contentId ?? event?.event?.contentId ?? null
	//console.debug("helper contentId", val)
	return val
}
